module.exports = __webpack_public_path__ + "static/media/product1.081bf019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product1.jpg
// module id = 1312
// module chunks = 0